import '@vanilla-extract/css/vanilla.virtual.css?ve-css=LnU4Nm53MCB7CiAgcGFkZGluZzogMC42NXJlbTsKICBiYWNrZ3JvdW5kOiBibGFjazsKICBib3JkZXItcmFkaXVzOiAwLjVyZW07Cn0';
import '@vanilla-extract/css/vanilla.virtual.css?ve-css=LnU4Nm53MSB7CiAgY29sb3I6IHdoaXRlOwp9';
export var Pill = 'u86nw0';
export var PillText = 'u86nw1';